<template>
  <div>
    <div class="top">
      <div class="top-panels">
        <panel
          class="top-panel"
          :panelAttr="getPanelAttr('coverage-rate')"
          :panelData="getPanelData('coverage-rate')"
        />
        <panel
          class="top-panel"
          :panelAttr="getPanelAttr('item-page-views')"
          :panelData="getPanelData('item-page-views')"
        >
          <vs-page-views
            :total="getPanelData('item-page-views').total"
            :withVS="getPanelData('vs-item-page-views').total"
          />
        </panel>
      </div>
      <TopChartWrapper :coverageData="chartData" />
    </div>
    <h2 class="item-details">
      Item Detail Totals
    </h2>
    <div v-if="isAvailableMonth">
      <div class="item-coverage">
        <panel
          :panelAttr="getPanelAttr('tm_status')"
          :panelData="itemPanelData"
        />
        <item-coverage-chart-wrapper :itemCoverageTotals="getPanelData('tm_status')" />
      </div>
      <div class="items-updated">
        <tabs />
      </div>
    </div>
    <div v-else>
      <no-data-month />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { COVERAGE_CHART_DEFINITION } from '@/misc/desktopCharts'
import Panel from './top/Panel'
import VsPageViews from './top/VsPageViews'
import TopChartWrapper from './top/chart/Index'
import NoDataMonth from './itemCoverage/noDataMonth/Index'
import ItemCoverageChartWrapper from './itemCoverage/chart/Index'
import Tabs from './itemCoverage/itemsUpdated/Index'
export default {
  components: {
    Panel,
    VsPageViews,
    TopChartWrapper,
    NoDataMonth,
    ItemCoverageChartWrapper,
    Tabs
  },
  computed: {
    ...mapGetters({
      chartData: 'charts/currentCharts',
      selectedDate: 'charts/coverageSelectedDate'
    }),
    isAvailableMonth () {
      // only available from March 2019
      return this.selectedDate >= new Date(2019, 2, 1)
    },
    itemPanelData () {
      let itemData = this.chartData['tm_status']
      return {
        ...itemData,
        total: itemData['total-percentage']
      }
    }
  },
  methods: {
    getPanelAttr (name) {
      return COVERAGE_CHART_DEFINITION.find(chart => chart.name === name)
    },
    getPanelData (name) {
      return this.chartData[name]
    }
  }
}
</script>

<style scoped lang="scss">
.top {
  border: $border-base;
  border-radius: $border-radius;
  background: $white;
}

.top-panels {
  display: flex;
}

.top-panel {
  width: 50%;

  &:first-child {
    border-right: $border-light;
  }
}

.item-details {
  margin-top: 40px;
  font-size: 26px;
}

.item-coverage {
  margin: 10px auto 40px;
  border: $border-base;
  border-radius: $border-radius;
  background: $white;
}
</style>
<style>
.squeezer {
  width: 137px !important;
  margin-left: 70px !important;
}
</style>
